export default [
    { key: 'code', label: 'ID', sortable: false },
    { key: 'name', label: 'Nombre' },
    { key: 'created_by.name', label: 'Creador' },
    { key: 'description', label: 'Descripción' },
    { key: 'created_at', label: 'Fecha creación' },
    { key: 'due_date', label: 'Fecha vencimiento' },
    { key: 'require_files', label: '¿Requiere archivos?'},
    { key: 'notes', label: 'Notas', sortable: false },
    { key: 'files', label: 'Archivos', sortable: false },
    { key: 'actions', label: 'Acciones' },
]